<template>
    <transition name="fade">
        <div class="succ-dialog-ctn" :class="{'show': show}">
            <div class="succ-dialog">
              <a href="javascript:;" class="close-btn" @click="closeDialog"></a>
              <div class="dialog-header">
                  <img src="//res.uuudian.com/hk_data/b92f189d-d615-47b2-ad5f-b6958e875971" alt="">
              </div>
              <div class="dialog-body">
                  <div class="dialog-msg">兑换成功</div>
              </div>
              <a href="javascript:;" @click="gotoWallet">
                  <div class="dialog-action">
                      <span class="icon-wallet"></span>
                      <span class="text">去“我的卡包”看看</span>
                      <span class="icon-arrow-right"></span>
                  </div>
              </a>
              <a href="javascript:;" @click="gotoPresent" v-if="present">
                  <div class="dialog-action present-item">
                      <span class="icon-wallet"></span>
                      <span class="text">获得<span style="color: #ff0000">{{present}}片</span>碎片，去看看</span>
                      <span class="icon-arrow-right"></span>
                  </div>
              </a>
              <div class="dialog-actions">
                  <button @click="closeDialog">继续购买</button>
              </div>
          </div>
          <div class="mask"></div>
        </div>

    </transition>
</template>

<script>
import store from '../../../api/store'

export default {
  data() {
    return {
      show: false,
      gotoWalletCb: null,
      present: ''
    };
  },
  watch: {
    show(val){
      if(val){ //reload when it show
        this.reload();
      }
    }
  },
  methods: {
    closeDialog(){
      this.show = false;
    },
    gotoWallet(){
        if(this.gotoWalletCb){
            this.gotoWalletCb();
        }
        this.closeDialog();
    },
    gotoPresent() {
      var url = process.env.lotteryLoginUrl;
      location.href = url;
    },
    reload(){
      this.present = store.present;
    }
  }
};
</script>

<style lang="less" scoped>
.present-item {
  margin-top: 0;
  border-top: 0;
}
.succ-dialog-ctn{
    display: none;
    box-sizing:border-box;

    &.show{
      display: block;
    }

    .succ-dialog{
        position: fixed;
        top: 50%;
        margin-top: -37.8vw;
        left: 50%;
        width: 85.333vw;
        margin-left: -45.666vw;
        background: #fff;
        border-radius: 1vw;
        z-index: 99;
        padding-top: 0;
        padding-left: 3.46vw;
        padding-right: 3.46vw;
        padding-bottom: 3.46vw;

        .dialog-header {
            text-align: center;
            padding-top: 7.73vw;

            img{
                width: 9.06vw;
            }
        }

        .dialog-body .dialog-msg{
            font-size: 4.8vw;
            color: #333;
            line-height: 2em;
            text-align: center;
        }

        .dialog-action{
            margin-top: 5.066vw;
            border-top: .2vw solid #eee;
            border-bottom: .2vw solid #eee;
            position: relative;
            height: 13.33vw;


            .icon-wallet{
                display: inline-block;
                background-image: url(//res.uuudian.com/hk_data/2b511614-390f-4fd2-9756-73dc5a0a2655);
                background-repeat: no-repeat;
                background-position: center;
                background-size: cover;
                width: 6.666vw;
                height:  6.666vw;
                position: absolute;
                left: 0;
                top: 50%;
                margin-top: -3.333vw;
            }

            .text{
                position: absolute;
                left: 8.266vw;
                top: 50%;
                margin-top: -2vw;
                font-size: 4vw;
                color: #81838e;
            }

            .icon-arrow-right{
                display: inline-block;
                background-image: url(//res.uuudian.com/hk_data/2bb8f508-dde3-4e68-8187-0f0506b03d6d);
                background-repeat: no-repeat;
                background-position: center;
                background-size: cover;
                width: 4vw;
                height: 4vw;
                position: absolute;
                right: 0vw;
                top: 50%;
                margin-top: -2vw;
                opacity: .8;
            }
        }

        .close-btn{
            display: inline-block;
            background-image: url(http://res.uuudian.com/hk_data/5b79bd8e-26c9-4106-8893-7f56d1578e34);
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
            width: 3.46vw;
            height: 3.46vw;
            position: absolute;
            top: 3.46vw;
            right: 3.46vw;
        }
    }

    .mask{
      background: #000;
      opacity: .3;
      z-index: 98;
    }
}


.succ-dialog-ctn .dialog-actions{
    width: 100%;
    margin: 5.06vw auto 0;
}

.succ-dialog-ctn .dialog-actions button{
    width: 100%;
    color: #fff;
    background: #09ba07;
    border: none;
    border-radius: 1.066vw;
    font-size: 4.8vw;
    height: 11.733vw;
}

.fade-enter-active,
.fade-leave-active {
  transition: 0.3s ease;
}
.fade-enter {
  opacity: 0;
  transform: scale(1);
}
.fade-leave-to {
  opacity: 0;
  transform: scale(0.9);
}

</style>


// WEBPACK FOOTER //
// src/components/global/purchaseDialog/purchaseDialog.vue